import EconomicCalendarV2Table from "@/ui-components/economic-calendar-v2-table";

function EconomicCalendarV2() {
  return (
    <EconomicCalendarV2Table bodyRowClassNames="text-xs font-medium text-gray-900 dark:text-gray-100" />
  );
}

export default EconomicCalendarV2;
